export const parserAPI = (res) => {
  return new Promise((resolve, reject) => {
    if (res.ok) {
      const json = res.json();
      json.then((data) => {
        if (data.success) {
          const parsed = data.data;
          resolve(parsed);
        } else {
          reject(data.message);
        }
      });
    } else {
      reject(res.statusText);
    }
  });
};
